/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class MapService extends __BaseService {
static readonly getSignaturForklaringPath = '/map/SignaturForklaring';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param kortKode undefined
   * @return Success
   */
  private getSignaturForklaringResponse(kortKode?: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (kortKode != null) __params = __params.set('kortKode', kortKode.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/map/SignaturForklaring`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param kortKode undefined
   * @return Success
   */
  getSignaturForklaring(kortKode?: string): __Observable<string> {
    return this.getSignaturForklaringResponse(kortKode).pipe(
      __map(_r => _r.body as string)
    );
  }
}

module MapService {
}

export { MapService }
